(ns ui.collapsible
  (:require
   ["lucide-react" :refer [ChevronRight]]
   ["@radix-ui/react-collapsible" :refer [Content Root Trigger]]
   [ui.utils :refer [clsx separate-props]]))

(defn collapsible-root [& args]
  (let [[props children] (separate-props args)]
    (into [:> Root props] children)))

(defn collapsible-trigger [& args]
  (let [[props children] (separate-props args)]
    [:> Trigger
     (assoc (dissoc props :mark :icon :icon-right :label)
            :class (clsx "flex gap-0.5 py-0.5 cursor-pointer items-center group w-full font-medium radix-state-open:[&>svg]:rotate-90"
                         (:class props)))
     (when-not (:icon-right props)
       [:> ChevronRight {:size 20 :class "leading-zero align-top transition-transform"}])
     (when (:icon props)
       [:> (:icon props) {:size 16 :class "leading-zero align-top mr-1 text-kleene-icon"}])
     (into [:div {:class "flex-1 text-left text-ellipsis whitespace-nowrap overflow-hidden"}] children)
     [:span {:class "text-[10px] text-kleene-text-secondary"} (:label props)]
     (when (:mark props)
       [:div {:class "flex justify-end items-center flex-1 ml-1"} (:mark props)])
     (when (:icon-right props)
       [:> ChevronRight {:size 20 :class "leading-zero align-top transition-transform"}])]))

(defn collapsible-content [& args]
  (let [[props children] (separate-props args)]
    (into [:> Content props] children)))
